import apiHeader from '@/helpers/apiHeader';

const kimapService = {
    list(params) {
        return apiHeader.get('general-master-data/kimaps', { params });
    },
    tree() {
        return apiHeader.get('general-master-data/kimaps/tree');
    },
    create(data) {
        return apiHeader.post('general-master-data/kimaps', data);
    },
    update(id, data) {
        return apiHeader.put(`general-master-data/kimaps/${id}`, data);
    },
    delete(id) {
        return apiHeader.delete(`general-master-data/kimaps/${id}`);
    },
};

export default kimapService;
